import { Flag, Music, Theater, Trophy } from "lucide-react";
import { Page } from "@/components/Page";
import { PageShell } from "@/components/PageShell";
import { EditorialCard } from "@/components/EditorialCard";
import { FadeUp, SectionIntro } from "@/components/Reveal";
import { LuxButton } from "@/components/LuxButton";
import { useUI } from "@/context/UIContext";
import { IMG } from "@/lib/images";

const CATEGORIES = [
  {
    image: IMG.f1,
    icon: Flag,
    category: "Motorsport",
    title: "Sporting events",
    description: "Paddock Club at Monaco, Centre Court at Wimbledon, ringside in Las Vegas.",
    testId: "tickets-card-sporting",
  },
  {
    image: IMG.concert,
    icon: Music,
    category: "Live Music",
    title: "Concerts",
    description: "Sold-out tours, private boxes and after-show access worldwide.",
    testId: "tickets-card-concerts",
  },
  {
    image: IMG.theatre,
    icon: Theater,
    category: "Stage",
    title: "Theatre & opera",
    description: "Opening nights in the West End, Broadway, Milan and Vienna.",
    testId: "tickets-card-theatre",
  },
  {
    image: IMG.tennis,
    icon: Trophy,
    category: "Hospitality",
    title: "VIP hospitality",
    description: "Hosted suites, chef's tables and members' enclosures — internationally.",
    testId: "tickets-card-hospitality",
  },
];

export default function Tickets() {
  const { openEnquiry } = useUI();
  return (
    <Page testId="tickets-page">
      <PageShell
        testId="tickets-hero"
        eyebrow="Tickets & Access"
        title={
          <>
            Access to the <span className="gold-text italic">unobtainable.</span>
          </>
        }
        intro="When the box office reads sold out, our work begins. MDS Arabama holds relationships — not waiting lists — across sport, stage and live performance."
        image={IMG.theatre}
        imageAlt="Grand theatre stage bathed in warm golden light"
      >
        <section className="mx-auto max-w-[1280px] px-6 py-24 md:py-32 lg:px-12">
          <SectionIntro
            eyebrow="The Portfolio"
            title="Every seat is the best seat"
            subtitle="Sporting events, concerts, theatre, VIP hospitality, sold-out and international occasions — presented editorially, arranged privately."
          />
          <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {CATEGORIES.map((c, i) => (
              <EditorialCard key={c.title} {...c} static delay={i * 0.1} onCta={() => openEnquiry("Tickets")} />
            ))}
          </div>
        </section>

        <section className="border-t border-[rgba(200,164,93,0.14)] bg-[#080808] py-24 md:py-28">
          <div className="mx-auto flex max-w-[1280px] flex-col items-start gap-8 px-6 lg:flex-row lg:items-center lg:justify-between lg:px-12">
            <FadeUp>
              <h2 className="max-w-xl font-serif text-3xl font-medium leading-tight text-ivory sm:text-4xl">
                If it has a guest list, <span className="gold-text italic">we are on it.</span>
              </h2>
            </FadeUp>
            <FadeUp delay={0.15}>
              <LuxButton onClick={() => openEnquiry("Tickets")} arrow testId="tickets-page-enquire-button">
                Request Access
              </LuxButton>
            </FadeUp>
          </div>
        </section>
      </PageShell>
    </Page>
  );
}
